export default __webpack_public_path__ + "static/media/gallery-fudge_01.f6451455.jpg";